import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseGuard } from './base.guard';
import { ConfigService } from '../../config/config.service';
import Enums from '../../shared/enum/enums';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceGuard extends BaseGuard {
  protected code: Enums.Workspace;
  get workSpace() {
    return this.code;
  }

  constructor(private readonly configService: ConfigService) {
    super();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const valid = this.validateParam(Enums.UrlParameter.workspace, next);
    if (valid !== true) {
      return valid;
    }

    const workSpaceConfig = this.configService.getArbeitsbereichConfig(this.code);
    if (!workSpaceConfig.isActive) {
      const activeWs = this.configService.arbeitsbereichConfig.arbeitsbereiche.find(ws => ws.isActive === true);
      activeWs.isActive = false;
      workSpaceConfig.isActive = true;
    }
    return true;
  }
}
